import { render, staticRenderFns } from "./wuyeXiangQing.vue?vue&type=template&id=0d30c83e&scoped=true"
import script from "./wuyeXiangQing.vue?vue&type=script&lang=js"
export * from "./wuyeXiangQing.vue?vue&type=script&lang=js"
import style0 from "./wuyeXiangQing.vue?vue&type=style&index=0&id=0d30c83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30c83e",
  null
  
)

export default component.exports